// @flow

import React       from 'react';
import Iframe      from './iframe';
import './tabItems.css';

const TabItems = ({ categories, handleActiveCategory, activeCategory } :
  { categories: Array<Object>, handleActiveCategory: Function, activeCategory: Object }) => {

  const getLinkClass = (item, index) => {
    if (activeCategory) {
      return activeCategory.id === item.id ? 'active' : '';
    } else {
      return index === 0 ? 'active' : '';
    }
  }

  return (
    <div className="tab-items js-tab-items">
      <ul className="filter">
        {categories.map((item, index) => (
          <li key={index} className={getLinkClass(item, index)} onClick={() => { handleActiveCategory(item.id) }}>
            <a className="js-category-link category-link" data-toggle='tab' aria-expanded='true'>{item.name}</a>
          </li>
         )
        )}
      </ul>

      <div className="holder">
        <div className="tab-content">
          {activeCategory && activeCategory.iframe && <Iframe iframe={activeCategory.iframe} />}
        </div>
      </div>
    </div>
  )
};

export default TabItems;



// WEBPACK FOOTER //
// ./src/components/main/specialDeals/tabItems.js